import { motion } from 'framer-motion'
import { Heart } from 'lucide-react'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  const footerLinks = [
    {
      title: 'Services',
      links: ['IoT Solutions', 'Web Development', 'Mobile Apps', 'Consulting']
    },
    {
      title: 'Company',
      links: ['About Us', 'Projects', 'Team', 'Contact']
    },
    {
      title: 'Resources',
      links: ['Blog', 'Documentation', 'Support', 'Privacy Policy']
    }
  ]

  return (
    <footer className="py-12 px-6 border-t border-white/10 bg-slate-950">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Brand Section */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img src="/logo.png" alt="Logo" className="w-10 h-10 rounded-lg" />
              <h3 className="text-lg font-bold bg-gradient-to-r from-blue-400 to-blue-600 bg-clip-text text-transparent">
                Nahid's IoT
              </h3>
            </div>
            <p className="text-sm text-white/60 leading-relaxed">
              Delivering innovative IoT, web, and mobile solutions that connect the physical and digital worlds.
            </p>
          </div>

          {/* Links Sections */}
          {footerLinks.map((section, index) => (
            <div key={index}>
              <h4 className="font-semibold mb-4 text-blue-400">{section.title}</h4>
              <ul className="space-y-2">
                {section.links.map((link, idx) => (
                  <li key={idx}>
                    <a
                      href="#"
                      className="text-sm text-white/60 hover:text-blue-400 transition-colors"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Section */}
        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-white/60 flex items-center gap-2">
              © {currentYear} Nahid's IoT & Software Solutions. All rights reserved.
            </p>
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.5 }}
              className="text-sm text-white/60 flex items-center gap-2"
            >
              Made with <Heart size={14} className="text-red-400 fill-red-400" /> in Bangladesh
            </motion.p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
